module.exports = __webpack_public_path__ + "src/assets/img/m-2.762e8b53.svg";